var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgClockBlue(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 27,
    viewBox: "0 0 26 27",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "time/clock"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M23.8332 13.4669C23.8332 19.4469 18.9798 24.3002 12.9998 24.3002C7.01984 24.3002 2.1665 19.4469 2.1665 13.4669C2.1665 7.48689 7.01984 2.63356 12.9998 2.63356C18.9798 2.63356 23.8332 7.48689 23.8332 13.4669Z",
    stroke: "currentColor",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M17.0191 16.9119L13.6608 14.9077C13.0758 14.5611 12.5991 13.7269 12.5991 13.0444V8.60274",
    stroke: "currentColor",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClockBlue);
export default __webpack_public_path__ + "static/media/clock-blue.cadfbe363aad05dd8c91f8cd886d4eb2.svg";
export { ForwardRef as ReactComponent };